module.exports = __webpack_public_path__ + "img/flex-back.af43aab4.png";